export default __webpack_public_path__ + "static/media/cat-icon.1ce56ca9.png";